export default function TextArea({ register, ...props }) {
  const validationRules = {};

  if (props.required) {
    validationRules.required = {
      value: true,
      message: props.requiredMessage || "This field is required",
    };
  }

  if (props.minLength) {
    validationRules.minLength = {
      value: props.minLength,
      message: props.validationMessage || `Minimum length is ${props.minLength} characters`,
    };
  }

  const error = props.errors?.[props.registerItem];

  return (
    <div>
      <label
        htmlFor={props.registerItem}
        className="block mb-2 text-sm font-medium text-gray-90"
      >
        {props.label}
      </label>
      <textarea
        {...register(props.registerItem, validationRules)}
        id={props.registerItem}
        className={`bg-white shadow-md text-gray-900 text-sm rounded-lg focus:ring-black focus:border-black block w-full p-2.5 lg:text-lg resize-none ${error ? 'border-2 border-red-500' : ''}`}
        placeholder={props.placeholder}
        minLength={props.minLength}
      ></textarea>
      {error && (
        <p className="mt-2 text-sm text-red-600">
          {error.message}
        </p>
      )}
    </div>
  );
}
